import { render, staticRenderFns } from "./AppHeaderAuthenticated.vue?vue&type=template&id=0ba2bf0c&"
import script from "./AppHeaderAuthenticated.vue?vue&type=script&setup=true&lang=js&"
export * from "./AppHeaderAuthenticated.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports